import { motion } from "framer-motion";

export const PageHero = ({ eyebrow, title, subtitle, image }) => (
  <section className="relative pt-40 pb-20 sm:pt-48 sm:pb-28 overflow-hidden">
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" aria-hidden="true" loading="lazy" decoding="async" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-primary/70" />
      </div>
    )}
    <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8">
      <motion.p initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className={`text-xs tracking-[0.3em] uppercase font-semibold mb-4 ${image ? "text-secondary" : "text-secondary"}`}>
        {eyebrow}
      </motion.p>
      <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.1 }}
        className={`font-serif text-4xl sm:text-6xl lg:text-7xl leading-none tracking-tight ${image ? "text-primary-foreground" : "text-primary"}`}>
        {title}
      </motion.h1>
      {subtitle && (
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6, delay: 0.25 }}
          className={`mt-6 text-lg max-w-2xl leading-relaxed ${image ? "text-primary-foreground/85" : "text-muted-foreground"}`}>
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
